import { InfoOutlined } from "@mui/icons-material";
import { Box, Grid2, IconButton, Popover, Typography } from "@mui/material";
import { GridSize, SxProps } from "@mui/system";
import { Markdown } from "@pimo/pimo-components";
import { type PropsWithChildren, type ReactNode, useState } from "react";

export type FormFieldWrapperProps = {
  description?: string;
  infoSlot?: ReactNode;
  label?: string | ReactNode;
  fieldWrapperSx?: SxProps;

  uiOptions?: {
    fieldSize?: Record<string, GridSize>;
    skinnyLabel?: boolean;
    centerItems?: boolean;
    narrowInfoSlotIcon?: boolean;
  };
};

export const FormFieldWrapper: React.FC<
  PropsWithChildren<FormFieldWrapperProps>
> = ({
  label,
  description,
  infoSlot,
  uiOptions: { fieldSize, skinnyLabel, centerItems, narrowInfoSlotIcon } = {},
  children,
  fieldWrapperSx = {},
}) => {
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLButtonElement | null>(
    null
  );

  return (
    <Grid2 size={fieldSize ?? { xs: 12 }}>
      {label && typeof label === "string" ? (
        <Typography
          sx={{ fontWeight: !skinnyLabel ? 500 : undefined, fontSize: "14px" }}
          gutterBottom
        >
          {label}
        </Typography>
      ) : (
        label
      )}
      {description && <Markdown>{description}</Markdown>}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: centerItems ? "center" : "inherit",
        }}
      >
        <Box sx={{ flex: "1 1 100%", position: "relative", ...fieldWrapperSx }}>
          {children}
        </Box>
        {infoSlot && (
          <Box
            sx={{
              flex: "0 0 60px",
              display:
                infoSlot || !fieldSize || fieldSize?.xs === 12
                  ? "flex"
                  : "none",
              alignItems: "flex-start",
              justifyContent: narrowInfoSlotIcon ? "flex-start" : "flex-end",
              paddingTop: label ? "7px" : "2px",
            }}
          >
            <>
              <IconButton
                onClick={(e) => setPopoverAnchor(e.target as HTMLButtonElement)}
              >
                <InfoOutlined />
              </IconButton>
              <Popover
                open={!!popoverAnchor}
                anchorEl={popoverAnchor}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                onClose={() => setPopoverAnchor(null)}
              >
                {infoSlot}
              </Popover>
            </>
          </Box>
        )}
      </Box>
    </Grid2>
  );
};
